module.exports = __webpack_public_path__ + "static/telefono-0dd5bfc56479efd652707ca64567e80f.jpg";